import * as React from 'react';
import { Create, SimpleForm, TextInput, required, TranslatableInputs } from "react-admin";
import { locales } from "../enum/locales";
import { RichTextInput, RichTextInputToolbar } from "ra-input-rich-text";

export const ContentCreateForm = () => (
  <SimpleForm>
    <TextInput source="code" validate={[required()]} />
    <TranslatableInputs locales={locales} defaultLocale="en" fullWidth={true} >
      <TextInput source="title" validate={[required()]} />
      <RichTextInput source="description" variant={"filled"} fullWidth={true} toolbar={<RichTextInputToolbar size="large" />} />
    </TranslatableInputs>
  </SimpleForm>
);
export const ContentCreate = () => (
  <Create>
    <ContentCreateForm />
  </Create>
);

